/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CurrencyEnum } from './CurrencyEnum';
import type { FileRequest } from './FileRequest';
import type { Languages } from './Languages';
import type { ProjectPartRequest } from './ProjectPartRequest';

export type ProjectUpdateRequest = {
  deadline?: string;
  /**
   * The languages of the project. 2 letters (en, de, it...) defaults to ['en'].
   */
  languages?: Array<Languages>;
  /**
   * The reason why buyer is creating project. This is an enum.
   */
  reasonForRequest?: ProjectUpdateRequest.reasonForRequest;
  deliveryDate?: string | null;
  /**
   * External Id of the Project (optional)
   */
  projectId?: string | null;
  note?: string | null;
  incoterms?: ProjectUpdateRequest.incoterms | null;
  /**
   * Currencies accepted for quotes
   */
  currencies?: Array<CurrencyEnum>;
  parts?: Array<ProjectPartRequest>;
  additionalFiles?: Array<FileRequest>;
  /**
   * The IDs of the required certifications
   */
  certifications?: Array<string>;
  /**
   * The update notes
   */
  updateNote?: string;
};

export namespace ProjectUpdateRequest {
  /**
   * The reason why buyer is creating project. This is an enum.
   */
  export enum reasonForRequest {
    BENCHMARKING = 'BENCHMARKING',
    NEW_PRODUCT = 'NEW_PRODUCT',
    SECOND_SOURCE = 'SECOND_SOURCE',
    SUPPLIER_FAILURE = 'SUPPLIER_FAILURE',
  }

  export enum incoterms {
    CFR = 'CFR',
    CIF = 'CIF',
    CIP = 'CIP',
    CPT = 'CPT',
    DAP = 'DAP',
    DAT = 'DAT',
    DDP = 'DDP',
    DPU = 'DPU',
    EXW = 'EXW',
    FAS = 'FAS',
    FCA = 'FCA',
    FOB = 'FOB',
  }
}
